import { cva, type VariantProps } from 'class-variance-authority';

export const badgeVariants = cva(
	'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
	{
		variants: {
			variant: {
				default:
					'border-transparent bg-primary text-primary-foreground hover:bg-primary/80',
				secondary:
					'border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80',
				destructive:
					'border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80',
				outline: 'text-foreground',
				grooming:
					'border-grooming-2 bg-grooming-1 text-grooming-4 dark:border-groom-surface dark:bg-groom-surface dark:text-grooming-2',
				vet:
					'border-vet-2 bg-vet-1 text-vet-4 dark:border-vet-surface dark:bg-vet-surface dark:text-vet-2',
				'grooming-upcoming':
					'border-grooming-2 bg-grooming-1 text-grooming-4 dark:border-groom-surface dark:bg-groom-surface dark:text-grooming-2',
				'vet-upcoming':
					'border-vet-2 bg-vet-1 text-vet-4 dark:border-vet-surface dark:bg-vet-surface dark:text-vet-2',
			success:
				'border-transparent bg-success/15 text-success dark:bg-success/20 dark:text-success',
				'grooming-solid':
					'border-transparent bg-grooming-4 text-grooming-1 dark:bg-grooming-3 dark:text-groom-surface',
				'vet-solid':
					'border-transparent bg-vet-4 text-vet-2 dark:bg-vet-3 dark:text-vet-surface',
				'green-solid': 'border-transparent bg-cta text-cta-foreground',
			warning:
				'border-transparent bg-amber-1 text-amber-4 dark:bg-amber-4/20 dark:text-amber-3',
			info:
				'border-transparent bg-muted text-muted-foreground',
			muted:
				'border-transparent bg-muted text-muted-foreground',
			danger:
				'border-transparent bg-destructive/10 text-destructive dark:bg-destructive/20 dark:text-destructive',
			},
		},
		defaultVariants: {
			variant: 'default',
		},
	},
);

export type BadgeVariants = VariantProps<typeof badgeVariants>;

/** Convenience alias for the variant prop union (e.g. 'default' | 'success' | 'destructive' | …). */
export type BadgeVariant = NonNullable<BadgeVariants['variant']>;
